module.exports = __webpack_public_path__ + "img/menu.26775e75.svg";